<template>
  <div :class="{'showTab':isShowTab}" >
    <div class="main-content-wrap">
      <div class="title anchor-item" ref="anchor-0">主要信息</div>
      <div class="content-h">
        <div class="content-h-l">
          <div class="content-h-l-img">
            <img v-if="detail.image" :src="detail.image" style="width: 84px;height: 84px;border-radius: 4px 4px 4px 4px;" class="pic" />
            <img v-if="!detail.image" src="~@/assets/def_avatar_84px.png" style="width: 84px;height: 84px;border-radius: 4px 4px 4px 4px;" />
          </div>
          <div class="content-h-l-c">
            <div style="display:flex;">
              <div class="name">{{ detail.reallyName || '--' }}</div>
              <div class="sex-m" v-if="detail.sex == '1'"></div>
              <div class="sex-w" v-else-if="detail.sex == '2'"></div>
              <div class="status" v-if="detail.statusLabel == '已转正'">{{ detail.statusLabel }}</div>
              <div class="status1" v-else-if="detail.statusLabel == '待离职'">{{ detail.statusLabel }}</div>
              <div class="status2" v-else-if="detail.statusLabel == '试用'">{{ detail.statusLabel }}</div>
            </div>
            <div style="display:flex;flex-wrap: wrap;margin-top:20px">
              <div class="text">员工工号：{{ detail.serial || '--' }}</div>
              <div class="text">职位：{{ detail.positionName || '--' }}</div>
              <div class="text">所属部门：{{ detail.orgName || '--' }}</div>
            </div>
          </div>
        </div>
        <div class="content-h-r">
          <div class="time">创建日期：</div>
          <div class="time">{{ detail.createdTimeFormat || detail.createdTime || '--' }}</div>
        </div>
      </div>
      <div class="content-c">
        <el-form :inline="true" class="l-form" size="small" label-width="92px">
          <el-form-item label="入职日期：">
            <div class="text-f">{{ detail.employeeDate || '--' }}</div>
          </el-form-item>
          <el-form-item label="直属上级：">
            <div class="text-f">{{ detail.directSuperior || '--' }}</div>
          </el-form-item>
          <el-form-item label="聘用形式：">
            <div class="text-f">{{ detail.jobNatureLabel || '--' }}</div>
          </el-form-item>
          <el-form-item label="工作手机号：">
            <div class="text-f">{{ detail.workPhone || '--' }}</div>
          </el-form-item>
          <el-form-item label="登录手机号：">
            <div class="text-f">{{ detail.phoneNumber || '--' }}</div>
          </el-form-item>
          <el-form-item label="手机号1：">
            <div class="text-f">{{ detail.extraPhoneFirst || '--' }}</div>
          </el-form-item>
          <el-form-item label="手机号2：">
            <div class="text-f">{{ detail.extraPhoneSecond || '--' }}</div>
          </el-form-item>
          <el-form-item label="钉钉登录手机号：" class="two-label">
            <template #label>
              <div class="custom-label">钉钉登录&nbsp;&nbsp;&nbsp;<br />手机号：</div>
            </template>
            <div class="text-f">{{ detail.dingPhone || '--' }}</div>
          </el-form-item>
          <el-form-item label="转正日期：">
            <div class="text-f">{{ detail.confirmationDate || '--' }}</div>
          </el-form-item>
          <el-form-item label="离职日期：">
            <div class="text-f">{{ detail.leaveTime || '--' }}</div>
          </el-form-item>
          <el-form-item label="更新日期：">
            <div class="text-f">{{ detail.updatedTimeFormat || detail.updatedTime || '--' }}</div>
          </el-form-item>
        </el-form>
      </div>
      <div class="split-line"></div>
      <div class="title anchor-item" ref="anchor-1">基础信息</div>
      <div class="content-c">
        <el-form :inline="true" class="l-form" size="small" label-width="92px">
          <el-form-item label="招聘信息来源：" class="two-label">
            <template #label>
              <div class="custom-label">招聘信息&nbsp;&nbsp;&nbsp;<br />来源：</div>
            </template>
            <!-- <template #label>
                                    <div
                                        style="line-height: 16px;width:106px;text-align:right;padding-right: 8px;box-sizing: border-box;">
                                        招聘信息来源：
                                    </div>
                                </template> -->
            <div class="text-f">{{ detail.recruitOriginLabel || '--' }}</div>
          </el-form-item>
          <el-form-item label="身份证号码：">
            <div class="text-f">{{ detail.idCardNumber || '--' }}</div>
          </el-form-item>
          <el-form-item label="出生日期：">
            <div class="text-f">{{ detail.dateOfBirth || '--' }}</div>
          </el-form-item>
          <el-form-item label="属相：">
            <template #label>
              属<span class="space"></span>相：
            </template>
            <div class="text-f">{{ detail.zodiacLabel || '--' }}</div>
          </el-form-item>
          <el-form-item label="民族：">
            <template #label>
              民<span class="space"></span>族：
            </template>
            <div class="text-f">{{ detail.nation || '--' }}</div>
          </el-form-item>
          <el-form-item label="最高学历：">
            <div class="text-f">{{ detail.educationalLevelLabel || '--' }}</div>
          </el-form-item>
          <el-form-item label="婚姻状况：">
            <div class="text-f">{{ detail.maritalStatusLabel || '--' }}</div>
          </el-form-item>
          <el-form-item label="汽(机)车驾照：" class="two-label">
            <template #label>
              <div class="custom-label">汽(机)车&nbsp;&nbsp;&nbsp;<br />驾照：</div>
            </template>
            <div class="text-f">{{ detail.drivingLicenseLevelLabel || '--' }}</div>
          </el-form-item>
          <el-form-item label="微信号：">
            <div class="text-f">{{ detail.wechatNumber || '--' }}</div>
          </el-form-item>
          <el-form-item label="邮箱地址：">
            <div class="text-f">{{ detail.email || '--' }}</div>
          </el-form-item>
          <el-form-item label="爱好/专长：">
            <div class="text-f">{{ detail.hobby || '--' }}</div>
          </el-form-item>
          <el-form-item label="身高(cm)：">
            <div class="text-f">{{ detail.height || '--' }}</div>
          </el-form-item>
          <el-form-item label="体重(kg)：">
            <div class="text-f">{{ detail.weight || '--' }}</div>
          </el-form-item>
          <el-form-item label="政治面貌：">
            <div class="text-f">{{ detail.politicalAffiliationLabel || '--' }}</div>
          </el-form-item>
          <el-form-item label="籍贯：">
            <template #label>籍<span class="space"></span>贯</template>
            <div class="text-f">{{ detail.nativePlace || '--' }}</div>
          </el-form-item>
          <el-form-item label="户口性质：">
            <div class="text-f">{{ detail.householdTypeLabel || '--' }}</div>
          </el-form-item>
          <!-- <el-form-item label="户口所在地：" label-width="106px">
                                <div class="text-f">{{ detail.householdResidence || '--' }}</div>
                            </el-form-item> -->
          <el-form-item label="身份证详细地址：" class="two-label">
            <template #label>
              <div class="custom-label">身份证&nbsp;&nbsp;&nbsp;<br />详细地址：</div>
            </template>
            <div class="text-f">{{
              detail.householdResidenceDetail || '--' }}
            </div>
          </el-form-item>
          <!-- <el-form-item label="现居住地：">
                                <div class="text-f">{{ detail.currentResidence || '--' }}</div>
                            </el-form-item> -->
          <el-form-item label="居住地详细地址：" class="two-label">
            <template #label>
              <div class="custom-label">居住地&nbsp;&nbsp;&nbsp;<br />详细地址：</div>
            </template>
            <!-- <div class="text-f">{{detail.currentResidenceDetail|| '--' }}</div> -->
            <div class="text-f">{{ detail.currentResidenceDetail || '--' }}</div>
          </el-form-item>
          <el-form-item label="紧急联系人姓名：" class="two-label">
            <template #label>
              <div class="custom-label">紧急联系人&nbsp;&nbsp;&nbsp;<br />姓名：</div>
            </template>
            <div class="text-f">{{ detail.emergencyContactName || '--' }}</div>
          </el-form-item>
          <el-form-item label="紧急联系人电话：" class="two-label">
            <template #label>
              <div class="custom-label">紧急联系人&nbsp;&nbsp;&nbsp;<br />电话：</div>
            </template>
            <div class="text-f">{{ detail.emergencyContactPhone || '--' }}</div>
          </el-form-item>
          <el-form-item label="原单位是否存在纠纷：">
            <template #label>
              <div class="custom-label">原单位是否&nbsp;&nbsp;&nbsp;<br />存在纠纷：</div>
            </template>
            <div class="text-dispute">
              <div class="text-f dispute-flag">
                {{ (detail.disputeFlag == 1 ? '是' : '否') || '--' }}
              </div>
              <div v-if="detail.dispute" class="dispute-info">{{ detail.dispute }}</div>
            </div>
          </el-form-item>
        </el-form>
        <div class="relative">
          <el-form :inline="true" class="l-form" size="small" label-width="92px">
            <el-form-item label="是否有亲戚/朋友在公司：" label-width="98px" style="margin-right: -6px;">
              <template #label>
                <div class="custom-label">是否有亲戚/&nbsp;&nbsp;<br />朋友在公司：</div>
              </template>
              <div class="text-f">
                {{ detail.kinFlag == 1 ? '是' : '否' || '--' }}
              </div>
            </el-form-item>
            <template v-if="detail.kinFlag == 1">
              <el-form-item label="其姓名：">
                <div class="text-f">{{ detail.kinName || '--' }}</div>
              </el-form-item>
              <el-form-item label="关系：">
                <template #label>关<span class="space"></span>系：</template>
                <div class="text-f">{{ detail.kinRelationship || '--' }}</div>
              </el-form-item>
              <el-form-item label="部门：">
                <template #label>部<span class="space"></span>门：</template>
                <div class="text-f">{{ detail.kinOrganization || '--' }}</div>
              </el-form-item>
            </template>
          </el-form>
        </div>
      </div>
      <div class="split-line"></div>
      <div class="title anchor-item" ref="anchor-2">工作履历<span style="font-weight: 400;font-size: 16px;color: #616363;">（时间由近至远）</span>
      </div>
      <div class="content-c">
        <div v-for="(item, index) in detail.workRecordList" :key="index">
          <div style="display:flex;justify-content:flex-start;align-items:center">
            <div class="sort-index">{{ index + 1 }}</div>
            <div class="sort-title">工作履历</div>
          </div>
          <el-form :inline="true" class="l-form" size="small" label-width="92px" style="margin-top:24px">
            <el-form-item label="起始日期：">
              <div class="text-f">{{ item.startTime || '--' }}</div>
            </el-form-item>
            <el-form-item label="结束日期：">
              <div class="text-f">{{ item.endTime || '--' }}</div>
            </el-form-item>
            <el-form-item label="单位名称：">
              <div class="text-f">{{ item.company || '--' }}</div>
            </el-form-item>
            <el-form-item label="任职部门：">
              <div class="text-f">{{ item.organization || '--' }}</div>
            </el-form-item>
            <el-form-item label="担任职位：">
              <div class="text-f">{{ item.post || '--' }}</div>
            </el-form-item>
            <el-form-item label="现离职原因：">
              <div class="text-f">{{ item.resignationReasonLabel || '--' }}</div>
            </el-form-item>
            <el-form-item label="工作收入：">
              <div class="text-f">{{ item.salary || '--' }}</div>
            </el-form-item>
            <el-form-item label="证明人：">
              <div class="text-f">{{ item.certifier || '--' }}</div>
            </el-form-item>
            <el-form-item label="联系电话：">
              <div class="text-f">{{ item.phone || '--' }}</div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="split-line"></div>
      <div class="title anchor-item" ref="anchor-3">教育经历<span style="font-weight: 400;font-size: 16px;color: #616363;">（学历由高至低）</span>
      </div>
      <div class="content-c">
        <div v-for="(item, index) in detail.educationList" :key="index">
          <div style="display:flex;justify-content:flex-start;align-items:center">
            <div class="sort-index">{{ index + 1 }}</div>
            <div class="sort-title">教育经历</div>
          </div>
          <el-form :inline="true" class="l-form" size="small" label-width="92px" style="margin-top:24px">
            <el-form-item label="起始日期：">
              <div class="text-f">{{ item.startTime || '--' }}</div>
            </el-form-item>
            <el-form-item label="结束日期：">
              <div class="text-f">{{ item.endTime || '--' }}</div>
            </el-form-item>
            <el-form-item label="学校名称：">
              <div class="text-f">{{ item.institutionName || '--' }}</div>
            </el-form-item>
            <el-form-item label="专业：">
              <template #label>专<span class="space"></span>业：</template>
              <div class="text-f">{{ item.major || '--' }}</div>
            </el-form-item>
            <el-form-item label="学历：">
              <template #label>学<span class="space"></span>历：</template>
              <div class="text-f">{{ item.educationalLevelLabel || '--' }}</div>
            </el-form-item>
            <el-form-item label="教育类型：">
              <div class="text-f">{{ item.educationalModeLabel || '--' }}</div>
            </el-form-item>

          </el-form>
        </div>
      </div>
      <div class="split-line"></div>
      <div class="title anchor-item" ref="anchor-4">家庭信息
      </div>
      <div class="content-c">
        <div v-for="(item, index) in detail.familyInfoList" :key="index">
          <div style="display:flex;justify-content:flex-start;align-items:center">
            <div class="sort-index">{{ index + 1 }}</div>
            <div class="sort-title">家庭成员</div>
          </div>
          <el-form :inline="true" class="l-form" size="small" label-width="92px" style="margin-top:24px">
            <el-form-item label="本人关系：">
              <div class="text-f">{{ item.familyRelationshipsLabel || '--' }}</div>
            </el-form-item>
            <el-form-item label="姓名：">
              <template #label>姓<span class="space"></span>名：</template>
              <div class="text-f">{{ item.name || '--' }}</div>
            </el-form-item>
            <!-- <el-form-item label="出生日期：">
                                    {{ item.dateOfBirth || '--' }}
                                </el-form-item> -->
            <el-form-item label="工作单位：">
              <div class="text-f">{{ item.company || '--' }}</div>
            </el-form-item>
            <el-form-item label="职务：">
              <template #label>职<span class="space"></span>务：</template>
              <div class="text-f">{{ item.post || '--' }}</div>
            </el-form-item>
            <el-form-item label="联系电话：">
              <div class="text-f">{{ item.phone || '--' }}</div>
            </el-form-item>
            <!-- <el-form-item label="是否为紧急联系人：">
                                    <template #label>
                                        <div style="line-height: 16px;width:96px;text-align:right;padding-right: 8px;box-sizing: border-box;">
                                            是否为<br>紧急联系人：
                                        </div>
                                    </template>
                                    <div class="text-f">{{ item.emergencyFlag == 1 ? '是' : '否' || '--' }}</div>
                                </el-form-item> -->
          </el-form>
        </div>
      </div>
      <div class="split-line"></div>
      <div class="title anchor-item" ref="anchor-5">培训经历<span style="font-weight: 400;font-size: 16px;color: #616363;">（非必填项）</span>
      </div>
      <div class="content-c">
        <div v-for="(item, index) in detail.trainingInfoList" :key="index">
          <div style="display:flex;justify-content:flex-start;align-items:center">
            <div class="sort-index">{{ index + 1 }}</div>
            <div class="sort-title">培训经历</div>
          </div>
          <el-form :inline="true" class="l-form" size="small" label-width="96px" style="margin-top:24px">
            <el-form-item label="起始日期：">
              <div class="text-f">{{ item.startTime || '--' }}</div>
            </el-form-item>
            <el-form-item label="结束日期：">
              <div class="text-f">{{ item.endTime || '--' }}</div>
            </el-form-item>
            <el-form-item label="培训方式：">
              <div class="text-f">{{ item.trainingModeLabel || '--' }}</div>
            </el-form-item>
            <el-form-item label="培训机构：">
              <div class="text-f">{{ item.institutionName || '--' }}</div>
            </el-form-item>
            <el-form-item label="获取证书：">
              <div class="text-f">{{ item.certificate || '--' }}</div>
            </el-form-item>
            <el-form-item label="培训内容：">
              <div class="text-f">{{ item.trainingContent || '--' }}</div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- <div class="split-line"></div> -->
      <div style="height: 20px;"></div>
    </div>
    <template  v-if="isShowTab">
      <transition name="el-fade-in">
        <div class="panel-right"  v-show="footer">
          <el-tabs tab-position="right" v-model="activeBtn" @tab-click="handleClickAchors" class="vertical-tabs" style="height: auto;">
            <el-tab-pane v-for="(item, index) in anchors" :key="index" :label="item.label" :name="String(index)"></el-tab-pane>
          </el-tabs>
        </div>
      </transition>
    </template>
  </div>
</template>
<script>
// 监听页面滚动的路由名称
const wathchPage = ['info','addApplication']
export default {
  name: 'EmplpymentDetail',
  data() {
    return {
      anchors: [
        {
          label: '主要信息',
          name: '1'
        },
        {
          label: '基础信息',
          name: '2'
        },
        {
          label: '工作履历',
          name: '3'
        },
        {
          label: '教育经历',
          name: '4'
        },
        {
          label: '家庭信息',
          name: '5'
        },
        {
          label: '培训经历',
          name: '6'
        }
      ],
      activeBtn: '0',//锚点按钮
      isGo: false, //是否滚动
    }
  },
  props: {
    detail: {
      type: Object,
      default: () => { },
    },
    pageActive: {
      type: String,
      required: false, // 可选
      default: '0'     // 默认值
    },
    footer: {
      type: Boolean,
      required: false, // 可选
      default: false   // 默认值
    }
  },
  computed: {
    isShowTab() {
      return wathchPage.includes(this.$route.name)
    }
  },
  watch: {
    pageActive(newValue, oldValue) {
       if (!this.isGo && this.activeBtn != newValue) {
        this.activeBtn = newValue
      }
    }
  },
  methods: {
    handleClickAchors(tab, event) {
      console.log(tab, event);
      this.activeBtn = String(tab.index)
      let selector = 'anchor-' + String(tab.index)
      console.log('>>', selector, this.$refs)
      this.$refs[selector].scrollIntoView({ behavior: 'smooth' })
      this.isGo = true
      setTimeout(() => {
        //点击滚动完成
        this.isGo = false
      }, 500);
    },
  },
}
</script>
<style lang='scss' scoped>
.split-line {
  // width: 1380px;
  height: 1px;
  background: #EDF2F2;
  border-radius: 0px 0px 0px 0px;
  margin-top: 14px;
}

.title {
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 16px;
  color: #2F3030;
  padding-top: 32px;
}

.content-h {
  width: 100%;
  height: 124px;
  background: #F8FAFA;
  border-radius: 4px 4px 4px 4px;
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  box-sizing: border-box;
  position: relative;

  .content-h-l {

    display: flex;
    justify-content: space-between;
    align-items: center;

    .pic {
      object-fit: cover;
    }

    .content-h-l-c {
      margin-left: 12px;

      .name {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 20px;
        color: #2F3030;
        line-height: 28px;
        text-align: left;
      }

      .sex-m,
      .sex-w {
        width: 24px;
        height: 24px;
        border-radius: 2px;
        margin: 4px 0 0 4px;
      }

      .sex-m {
        background-image: url('~@/assets/icon_nan.png');
      }

      .sex-w {
        background-image: url('~@/assets/icon_women.png');
      }

      .status {
        width: 54px;
        height: 24px;
        background: #E4F7F4;
        border-radius: 2px 2px 2px 2px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #00B498;
        line-height: 24px;
        text-align: center;
        margin-top: 4px;
        margin-left: 16px
      }

      .status1 {
        width: 54px;
        height: 24px;
        background: #FAF5E1;
        border-radius: 2px 2px 2px 2px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #F5C401;
        line-height: 24px;
        text-align: center;
        margin-top: 2px;
        margin-left: 22px
      }

      .status2 {
        width: 54px;
        height: 24px;
        background: #E8EEFA;
        border-radius: 2px 2px 2px 2px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #2D5DCF;
        line-height: 24px;
        text-align: center;
        margin-top: 2px;
        margin-left: 22px
      }

      .text {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #2F3030;
        margin-right: 40px;
      }
    }
  }

  .content-h-r {
    position: absolute;
    right: 20px;
    top: 32px;
    display: inline-flex;
    flex-wrap: wrap;

    .time {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #939696;
      line-height: 0px;
      flex-shrink: 0;
    }
  }
}

.content-c {
  margin-top: 23px;

  .l-form {
    color: #2F3030;

    .el-form-item {
      // width: 290px;
      width: 25%;
      margin-right: 0;
      display: inline-flex;
      align-items: flex-start;
      line-height: 32px;
      // background-color: red;
      min-height: 32px;

      &.two-label {
        .text-f {
          padding-top: 0;
          min-height: 32px;
        }
      }
    }

    /deep/ {
      .el-form-item__label {
        color: #939696;
        height: 32px;
        // font-weight: 400;
      }

      .el-form-item__content {
        width: calc(100% - 92px);
        line-height: 1;
        // min-height: 32px;

        //  background: red;
      }
    }

  }

  .text-f {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #2F3030;
    line-height: 16px;
    padding-top: 8px;
    //  min-height: 32px;
    word-break: break-all;
    display: inline-flex;
    align-items: center;


  }

  .text-dispute {
    flex-direction: column;
    align-items: flex-start;
  }

  .dispute-info {
    line-height: 16px;
    margin-top: 10px;
  }

  .relative {
    width: 100%;
    // height: 52px;
    padding: 8px 0 8px 0;
    background: #F8FAFA;
    border-radius: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #2F3030;

    .l-form {
      width: 100%;
    }

    .el-form-item {
      margin-bottom: 0;
      min-height: 32px;
    }
  }

  .sort-index {
    width: 16px;
    height: 16px;
    background: #E4F7F4;
    line-height: 16px;
    border-radius: 50%;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 12px;
    color: #00B498;
    text-align: center;
  }

  .sort-title {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 14px;
    color: #2F3030;
    margin-left: 2px;
  }
}

.main-content {
  margin-top: 30px;

}

.panel-right {
  padding-top: 10px;
  position: fixed;
  // 18% - 100px / 2
  right: calc(9% - 40px);
  top: 220px;

  /deep/ {
    .vertical-tabs {
      .el-tabs__active-bar {
        width: 3px !important;
        border-radius: 3px;
        top: 4px;
      }

      .el-tabs__nav-wrap::after {
        width: 1px;
        left: 1px;
      }
    }
  }

  .step-line {
    position: absolute;
    left: 6px;
    top: 0;
    width: 1px;
    background: #dcdfe6;
    height: calc(50vh - 85px);
    z-index: 0;
  }

  .step-ul {
    li {
      padding-bottom: 20px;

      .step-icon {
        width: 13px;
        height: 13px;
        margin-right: 20px;
        border-radius: 50%;
        z-index: 1;
      }

      .step-label {
        font-weight: 700;
        font-size: 14px;
        line-height: 22px;
        color: #303133;
      }
    }

    .step-active {
      .step-icon {
        border: 1px solid #1989fe;
        background: #fff;
      }

      .step-label {
        color: #1989fe;
      }
    }
  }
}
 
 .main-content-wrap{
        // height: calc(100vh -39px -47px -60px);
        height: calc(100vh - 182px);
        overflow: auto;
        padding-right: 32px;
    }
.showTab{
 .main-content-wrap{
      padding-right: 18%;
      height: initial;
    }
    
 @media screen and (min-width: 1251px) and (max-width: 1300px) {
  .main-content-wrap {
    padding-right: 12%;
  }
  /* 在这个区间内的样式 */
  .panel-right {
    // 12% - 100px / 2
    right: calc(6% - 20px);
  }
}
  // // 浏览宽度小于1300
  @media screen and (max-width: 1250px) {
    .main-content-wrap{
      padding-right: 0;
    }
    .panel-right{
      display: none;
    }
  }
}
 
</style>